export interface IQuickFilter {
  cliente: number;
  divisas: string[];
  denominaciones: number[];
  tipos: Array<"OFERTA" | "DEMANDA">;
}
export const iniQuickFilter: IQuickFilter = {
  cliente: -1,
  divisas: [],
  denominaciones: [],
  tipos: ["OFERTA", "DEMANDA"],
};
